import React, { useState, useEffect } from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import "./Products.css";

// components imports
import GRN from "../../../Pages/Products/GRN/GRN";
import Product from "../../Products/Product/WarehouseProduct";
import ProductStockCount from "../../Products/ProductStockCount/ProductStockCount";
import TransferRequest from "./TransferRequest/TransferRequest";
import TabsComponent from "../../../Components/Common/TabsComponent";
import WarehousePallet from "./Pallets/Pallets";
// apis imports
// library imports
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Products = () => {
  const { t } = useTranslation("warehouse");
  const location = useLocation();
  const transferId = location.state && location.state.transferId;

  const [tab, setTab] = useState(0);

  const setSnack = useSnackBar();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    if (transferId === "stockreceived") {
      setTab(2);
    } else {
      setTab(0);
    }
  }, []);

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >
      <TabsComponent
        items={[
          {
            label: t("products.allProductsCaps"),
            style: { fontWeight: "bold" },
            value: 0,
          },
          {
            label: t("products.allPallets"),
            style: { fontWeight: "bold" },
            value: 1,
          },
          {
            label: t("products.stockReceivedList"),
            style: { fontWeight: "bold" },
            value: 2,
          },
          {
            label: t("products.productCountStockCaps"),
            style: { fontWeight: "bold" },
            value: 3,
          },
          {
            label: t("products.transferRequestCaps"),
            style: { fontWeight: "bold" },
            value: 4,
          },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === 0 && <Product setSnack={setSnack} />}
      {tab === 1 && <WarehousePallet setSnack={setSnack} />}
      {tab === 2 && <GRN setSnack={setSnack} />}
      {tab === 3 && <ProductStockCount setSnack={setSnack} />}
      {tab === 4 && <TransferRequest setSnack={setSnack} />}
      {/* {tab === 3 && <TransferNote />}
      {tab === 4 && <BrandStock />}
      {tab === 5 && <Currency />}
      {tab === 6 && <Category />}
      {tab === 7 && <Unit />} */}
    </div>
  );
};

export default Products;
